import Model from '../Model';
import AqlQueryModel from './AqlQueryModel';

export default class BundleSpecModel extends Model {
	constructor(data) {
		super(data);
		this.queries = data.queries && data.queries.map(query => new AqlQueryModel(query)) || [];
	}

	build() {
		let buildResult = {
			queries: this.queries && this.queries.length && this.queries.map(query => query.build()) || []
		};
		return buildResult;
	}
}



// WEBPACK FOOTER //
// ./modules/distribution/core/models/distribution/BundleSpecModel.js